import { ZoneState } from ".";
import { config } from "config";
import { SelectOption } from "components/atoms/Select";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const default_page_size = config.PAGE_SIZE;
const initialState: ZoneState = {
	zones: [],
	zone: null,
	setZone_id:"",
	loading: true,
	zoneOptions:[],
	zonesList: [],
	count: 0,
	refresh: 0,
	refreshLoader: false,
	filters: { page: 1, page_size: default_page_size },

};

export const zoneSlice = createSlice({
	name: "zone",
	initialState,
	reducers: {
		clear: (state) => {
			state.zoneOptions = [];
			state.zone=null
			state.setZone_id=""
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		addZone: (state, action) => {
			state.zones.unshift(action.payload);
		},
		updateZone: (state, action) => {
			const { id, zone } = action.payload;
			
			state.zones.every(({ _id }, i) => {
				if (id === _id) {
					state.zones[i] = zone;
					return false;
				}
				return true;
			});
		},
		setZone: (state, action) => {
			state.zone = action.payload;
		},
		setZone_id: (state, action) => {
			state.setZone_id = action.payload;
		},
		setZones: (state, action) => {
			const zones = action.payload;
			let options: SelectOption[] = [];
			// Global zones = Stripe-enabled (is_stripe). Everything else is Local.
			zones.forEach(({ _id, name, is_stripe }: any) =>
				options.push({
					value: _id,
					label: name,
					group: is_stripe ? "Global Zones" : "Local Zones",
				})
			);
			// MUI Autocomplete needs options sorted by group so it renders a
			// single header per category (Global first, then Local).
			options.sort((a, b) =>
				a.group === b.group
					? (a.label || "").localeCompare(b.label || "")
					: a.group === "Global Zones"
					? -1
					: 1
			);
			state.zones = zones;
			state.zoneOptions = options;
		},
		setZonesList: (
			state,
			action: PayloadAction<{ zones: any[]; count: number }>
		) => {
			const { zones, count } = action.payload;
			state.zonesList = zones;
			state.count = count;
			state.refreshLoader = false;
			state.loading = false;
		},
		setPage: (state, action: PayloadAction<number>) => {
			state.filters.page = action.payload;
			state.refresh += 1;
			state.refreshLoader = true;
		},
		setFilters: (state, action) => {
			state.filters = action.payload;
			state.refresh += 1;
			state.refreshLoader = true;
		},
		resetFilters: (state) => {
			state.filters = initialState.filters;
			state.refresh += 1;
			state.refreshLoader = true;
		},
	},
});

const zoneReducer = zoneSlice.reducer;

export const zoneActions = zoneSlice.actions;
export default zoneReducer;
